<template>
  <div class="user-login" @keydown.enter="login" tabindex="0">
    <div class="form_area">
      <GoogleLoginServer
        :isLogin="true"
        @success="googleLogin"
        @click="googleLogin"
      ></GoogleLoginServer>
      <AppleLogin :isLogin="true" class="mt10"></AppleLogin>

      <div class="login_title">
        Log in with another Email
      </div>
      <div class="row">
        <div class="label">Email address</div>
        <TextBox
          class="text-box mail"
          :value="mail"
          placeholder=""
          @handleTextInput="inputMail"
        />
      </div>
      <div class="row">
        <div class="label">Password</div>
        <TextBox
          class="text-box password"
          :inputType="isShowPassword ? 'text' : 'password'"
          :value="password"
          placeholder=""
          @handleTextInput="inputPassword"
        >
        </TextBox>
      </div>
      <ErrorMessage
        v-if="errorMessage"
        class="error-message"
        :message="t(errorMessage)"
      />
      <div class="check-box-container">
        <CheckBox
          class="check-box"
          :isChecked="isChecked"
          :isBgWhite="true"
          @handleCheckBoxClick="toggleCheck"
        />
        <span class="text">Remember me</span>
      </div>
      <BlackGradationButton
        class="square-button login"
        text="Login"
        @handleSquareBtnClick="login"
      />
      <div class="forget-password">
        <span class="text" @click.stop="forgetPassword">Forgot password?</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TextBox from '@/components/atoms/TextBox.vue';
import CheckBox from '@/components/atoms/CheckBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import GoogleLoginServer from '@/components/atoms/GoogleLoginServer.vue';
import AppleLogin from '@/components/atoms/AppleLogin.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserLogin',
  mixins: [t],

  components: {
    TextBox,
    CheckBox,
    ErrorMessage,
    BlackGradationButton,
    GoogleLoginServer,
    AppleLogin,
  },

  data: () => ({
    mail: null,
    password: null,
    isChecked: false,
    isShowPassword: false,
    errorMessage: '',
  }),

  computed: {
    ...mapGetters({
      loginUserResult: 'user/loginUserResult',
      googleLoginResult: 'user/googleLoginResult',
    }),
  },

  created() {
    // appleってクエリパラメータがあるか確認
    const { apple, login_error: loginError } = this.$route.query;
    if (apple) {
      this.errorMessage = 'Email address or password do not match.';
    }
    if (loginError) {
      this.errorMessage = 'Email address or password do not match.';
    }
  },

  watch: {
    loginUserResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearLoginUserResult');
          const { packId } = this.$route.query;
          if (packId) {
            this.$router.push({ path: '/pack-detail', query: { packId } });
            return;
          }
          this.$router.push('/');
        } else {
          const { mail } = newVal.errors;
          this.errorMessage = mail ? mail[0] : null;
        }
      }
    },
    googleLoginResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearLoginUserResult');
          const { packId } = this.$route.query;
          if (packId) {
            this.$router.push({ path: '/pack-detail', query: { packId } });
            return;
          }
          this.$router.push('/');
        } else {
          window.alert(newVal.errors.mail[0]);
        }
      }
    },
  },

  methods: {
    inputMail(mail) {
      this.mail = mail;
    },
    inputPassword(password) {
      this.password = password;
    },
    toggleShowPassword() {
      this.isShowPassword = !this.isShowPassword;
    },
    toggleCheck() {
      this.isChecked = !this.isChecked;
    },
    login(e) {
      // 日本語入力中のEnterのkeyCode(229)の場合は何もしない。
      if (e && e.keyCode === 229) {
        return;
      }
      const postParams = {
        mail: this.mail,
        pass: this.password,
      };
      if (this.isChecked) {
        postParams.save_cookie = '1';
      }
      this.$store.dispatch('user/loginUser', { postParams });
    },
    forgetPassword() {
      this.$router.push('/password-reissue');
    },
    goToUserRegister() {
      this.$router.push('/user-register');
    },
    googleLogin() {
      window.location.href = '/api/user/google/login';
    },
  },

};
</script>

<style lang="scss" scoped>
.user-login{
  width: 100%;
  max-width: 800px;
  min-height: 100%;
  padding: 50px 20px;
  margin: 0px auto;
  text-align: center;
  outline: none;
  @include appendMap($backgroundStyleMap);
  background-color: $baseColor;
  border-top-left-radius: 0;
  position: relative;
  z-index: 1;
  .form_area {
    max-width: 680px;
    margin: auto;
    h2 {
      text-align: center;
      color: $white;
      font-weight: bold;
      font-size: 24px;
    }
    .row {
      margin: 20px 0;
      @media screen and  (max-width: $tabletWidth) {
        justify-content: center;
      }
      .label {
        color: $white;
        margin-bottom: 5px;
      }
    }
  }
  .label-password {
    margin-top: 20px;
  }
  .text-box{
    width: 315px;
    margin: 0px auto;
    &.mail{
      width: 100%;
    }
    &.password{
      width: 100%;
      .icon.eye{
        position: relative;
        margin: 0px 5px 0px 10px;
        .fa-eye, .fa-slash{
          font-size: 18px;
          line-height: 1.5;
          color: $brown;
        }
        .fa-slash{
          position: absolute;
          top: calc(50% - 8px);
          left: calc(50% - 11px);
        }
      }
    }
  }
  .error-message{
    width: 315px;
    margin: 0px auto;
  }
  .check-box-container{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto 20px;
    .check-box{
      width: 25px;
      height: 25px;
    }
    .text{
      margin-left: 10px;
      font-family: $notoSans;
      font-size: 14px;
      line-height: 1.8;
      color: $white;
    }
  }
  .square-button{
    width: 280px;
    height: 50px;
    margin: 10px auto 0px;
    border-radius: 100px;
    font-weight: bold;
  }
  .forget-password{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px auto 0px;
    color: $white;
    .text{
      font-family: $notoSans;
      font-size: 14px;
      cursor: pointer;
      transition: .4s;
      &:hover {
        opacity: .4;
      }
    }
    .fa-angle-right{
      margin-left: 10px;
      font-size: 21px;
      line-height: 27px;
      color: $deepGray;
    }
  }
  .description{
    text-align: center;
    height: 66px;
    margin-top: 10px;
    .alert {
      position: relative;
      font-size: 20px;
      font-weight: bold;
      color: #f86560;
      padding-left: 40px;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        background-image: url('/img/icons/alert_icon.png');
        background-position: center;
        background-size: 100%;
        background-repeat: no-repeat;
        width: 30px;
        height: 30px;
      }
    }
    .text{
      font-family: $notoSans;
      font-size: 13px;
      line-height: 23.4px;
      color: $white;
    }
  }
  .sub_box {
    margin-top: 30px;
    margin-bottom: 50px;
    h2 {
      color: $white;
    }
  }
}
.radio_area {
  label {
    display: flex;
    align-items: center;
    .radio {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    span {
      color: #fff;
    }
  }
}
.login_title {
  margin-top: 20px;
  color: #fff;
  border-bottom: solid 1px #fff;
}
@media screen and  (max-width: $tabletWidth) {
  .user-login{
    .form_area {
      padding: 0 20px;
    }
    .sub_box {
      margin-bottom: 20px;
    }
    .description{
      .alert {
        font-size: 18px;
        font-weight: bold;
        color: #f86560;
        padding-left: 30px;
        &:before {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
